

import { Component, Vue } from "vue-property-decorator"
import { namespace, Getter } from "vuex-class"

import cloneDeep from "lodash/cloneDeep"

import { Team, DashboardSummary } from "@/types"

import api from "@/services/api"
import dashboardApi from "@/services/api.dashboard"

import { BModal } from "bootstrap-vue"
import vSelect from "vue-select"
// @ts-ignore
import VuePerfectScrollbar from "vue-perfect-scrollbar"

import UserList from "@/components/Config/Users/UserList.vue"
import DataModal from "@/components/Config/DataModal.vue"
import ScrollTabs from "@/components/Controls/Tabs/ScrollTabs.vue"
import ScrollTab from "@/components/Controls/Tabs/ScrollTab.vue"
import { ExtendedPermission } from "@/types/user"
import PageWrapper from "@/components/New/Page/PageWrapper.vue"

const setup = namespace("setup")

@Component({
	components: {
		"page": PageWrapper,
		"v-select": vSelect,
		"scrollbar": VuePerfectScrollbar,
		"data-modal": DataModal,
		"user-list": UserList,
		"scroll-tab": ScrollTab,
		"scroll-tabs": ScrollTabs
	}
})
export default class UserSetup extends Vue {
	$refs!: { dataModal: BModal }

	@setup.Action
	public loadTeams!: () => Promise<void>;

	@setup.Getter("getTeams")
	public teams!: Team[];

	@setup.Action
	public getADEnabled!: () => Promise<boolean>

	@Getter("getIsSuiteEnabled") isSuiteEnabled! : boolean;

	currentTeamDashboards: DashboardSummary[] = []
	extendedPermissions: ExtendedPermission[] = []

	public filter: string = "";
	public adEnabled: boolean = false;

	public async mounted (): Promise<void> {
		api.extendedPermissionsGet().then(permissions => this.extendedPermissions = (permissions || []))
		await this.loadTeams()

		this.getADEnabled().then(enabled => this.adEnabled = enabled)
	}

	public get columns (): any[] {
		return [
			{
				key: "title",
				label: "Title",
				sortable: true,
				errors: (item: any) => item.title ? null : "Please enter a title",
				readonly: (item: any) => item.preventEdit || this.isSuiteEnabled
			},
			{
				key: "defaultDashboardId",
				label: "Default Dashboard",
				valueColumn: "defaultDashboardId",
				sortable: true,
				dataType: "list",
				options: this.currentTeamDashboards,
				inTable: false
			},
			{
				key: "editData",
				label: "Edit Data",
				sortable: true,
				dataType: "checkbox",
				inModal: (item: any) => !item.preventEdit
			},
			{
				key: "editUsers",
				label: "Edit Users",
				sortable: true,
				dataType: "checkbox",
				inModal: (item: any) => !item.preventEdit
			},
			{
				key: "editInsights",
				label: "Edit Insights",
				sortable: true,
				dataType: "checkbox",
				inModal: (item: any) => !item.preventEdit
			},
			...this.extendedPermissionColumns,
			{
				key: "adGroup",
				label: "Active Directory Group",
				inTable: false,
				inModal: (item: any) => this.adEnabled
			}
		]
	}

	public get extendedPermissionColumns () {
		return this.extendedPermissions
			? this.extendedPermissions.map(permission => {
				return {
					key: "extendedPermissions." + permission.key,
					label: permission.title,
					description: permission.description,
					dataType: "checkbox",
					inModal: (item: any) => !item.preventEdit
				}
			})
			: []
	}

	public get filteredTeams () {
		if (this.filter === "") {
			return this.teams
		}

		const lowerFilter = this.filter.toLowerCase()
		return this.teams.filter(team => team.title.toLowerCase().indexOf(lowerFilter) > -1)
	}

	public async save (team: Team): Promise<void> {
		try {
			await api.teamSave(team)
		} catch (err) {
			this.$bvToast.toast(err, {
				title: `Error saving team:  ${team.title}`,
				variant: "danger",
				solid: true,
				autoHideDelay: 10000
			})
		}

		await this.loadTeams()
	}

	public async createNewTeam (): Promise<void> {
		this.currentTeamDashboards = await dashboardApi.dashboardGetListForTeam("")
		this.$refs.dataModal.open({
		})
	}

	public async editTeam (team: Team): Promise<void> {
		this.currentTeamDashboards = await dashboardApi.dashboardGetListForTeam(team.id)
		this.$refs.dataModal.open(cloneDeep(team))
	}

	public async deleteTeam (team: any): Promise<void> {
		try {
			await api.teamDelete(team.id)
		} catch (err) {
			this.$bvToast.toast(err, {
				title: `Error deleting team: ${team.title}`,
				variant: "danger",
				solid: true,
				autoHideDelay: 10000
			})
		}

		await this.loadTeams()
	}
}

